{
  "form": {
    "input_placeholder": "Add a task…",
    "parseWithAi_aria": "Parse task with AI",
    "parseWithAi_title": "Clean up and set priority with AI",
    "priorityLabel_aria": "Task priority",
    "add": "Add",
    "signInForAi": "Sign in to use AI features.",
    "aiUnavailable": "AI unavailable. Try again.",
    "saveTo": "Save to",
    "saveTo_aria": "Save to {{list}}",
    "saveToSynced_aria": "Save to {{list}}, {{provider}}",
    "addedTo": "Added to {{list}}",
    "addedToSynced": "Added to {{list}} · {{provider}}",
    "show": "Show"
  },
  "priority": {
    "Critical": "Critical",
    "High": "High",
    "Medium": "Medium",
    "Low": "Low"
  },
  "item": {
    "edit_aria": "Edit task",
    "delete_aria": "Delete task",
    "addStep": "Add a step",
    "addStep_placeholder": "Add a step…",
    "addStep_aria": "Add a step to {{task}}",
    "steps_group_aria": "Steps of {{task}}",
    "steps_progress_aria": "{{done}} of {{count}} steps done",
    "completeSteps_aria": "{{task}}. Also completes {{count}} open steps"
  },
  "list": {
    "title": "Tasks",
    "newListFallback": "New List",
    "completedMeta": "{{completed}} of {{total}} completed",
    "deleteConfirm": "Delete \"{{name}}\"?",
    "rename_title": "Rename",
    "deleteList_title": "Delete list",
    "newListName_placeholder": "List name…",
    "newList": "New list",
    "done": "Done",
    "emptyTitle": "No tasks yet",
    "emptySubtitle": "Add one to get started.",
    "noFilterMatch": "No tasks match this filter.",
    "createIn": "Create in",
    "inDestination": "in {{destination}}",
    "createIn_aria": "Create in {{destination}}",
    "createInAccount_aria": "Create in {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Creating in {{destination}}…",
    "createFailed": "Couldn't create “{{name}}” in {{destination}}.",
    "createLimit": "{{destination}} has reached its list limit.",
    "keepInRhemn": "Keep in Rhemn"
  },
  "filter": {
    "label": "Filter",
    "all": "All"
  },
  "voice": {
    "mic_aria": "Add tasks by voice",
    "mic_title": "Speak your tasks — sorted by priority and time",
    "stop_aria": "Stop and sort tasks",
    "recording": "Recording",
    "sorting": "Sorting your tasks…",
    "stripTitle": "Tasks heard",
    "stripCount": "{{checked}} of {{total}}",
    "discard": "Discard",
    "addN": "Add {{count}}",
    "addZero": "Add",
    "adding": "Adding…",
    "parseFallback": "Couldn't sort that — your words are in the box.",
    "nothingHeard": "Didn't catch that — try again.",
    "micDenied": "Microphone access is blocked — allow it in settings.",
    "gateBody": "Speak your tasks — sorted by priority and prayer block. Included with Pro.",
    "listen_aria": "Listening — speak your tasks"
  }
}
